import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { AddShipmentContainer, IShipmentContainerBase, LogisticsActionKeys } from '..';
import { httpService } from '../../..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ApiUrls } from '../../ApiUrls';
import { executeApiRequest } from '../../asyncUtils';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { logisticsActionCreators } from '../logisticsActionCreators';

function* addShipmentContainerSaga(action: AddShipmentContainer) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(executeAdd, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(logisticsActionCreators.setContainer(response.value.value));
    }
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchAddShipmentContainer() {
  yield takeEvery(LogisticsActionKeys.ADD_SHIPMENT_CONTAINER, addShipmentContainerSaga);
}

async function executeAdd(val: {
  shipmentId: number;
  shipmentContainerTypeId: number;
}): Promise<IApiExecuteRespone<IEntityWithMessages<IShipmentContainerBase>>> {
  return executeApiRequest(() => httpService.post(`${ApiUrls.shipment()}/Containers/Create`, val));
}
